// Force a browser download. Critically Safari-compatible:
// the actual download MUST be triggered SYNCHRONOUSLY from within the click
// event handler — any `await` between click and `<a>.click()` causes Safari to
// drop the user-gesture context and silently block the download. So we cache
// the auth token in memory (via lib/api.js setAuthToken) at login and read it
// synchronously here.

import { API, getAuthToken } from "@/lib/api";

export function downloadServerFile(path, params = {}) {
  const token = getAuthToken();
  const url = new URL(`${API}${path}`);
  Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));
  if (token) url.searchParams.set("auth", token);

  // Open in a new tab. The server returns Content-Disposition: attachment
  // so the browser downloads the file and (in Safari) closes the empty tab.
  // target=_blank ensures iframe sandboxes don't block the download.
  const a = document.createElement("a");
  a.href = url.toString();
  a.target = "_blank";
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 1000);
}
